module.exports = __webpack_public_path__ + "img/group-title.3accd755.png";